import styled, {css} from 'styled-components'

type ContainerProps = {
  isSwiping?: boolean
  centerAlignItems?: boolean
  doTransitions?: boolean
  swipeable?: boolean
}

const swipeCursor = css`
  user-select: none;
  cursor: move;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`

export const Container = styled.div<ContainerProps>`
  display: flex;
  white-space: nowrap;
  ${(p): string => (!p.isSwiping ? `transition: transform 0.3s;` : 'transition: transform 0.1s;')}
  ${(p): string => (!p.doTransitions ? `transition: none;` : '')}
  ${(p): any => (p.swipeable ? swipeCursor : '')}
`
